import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
export default function Page4(){
    return <div>
        <h1 id='educationSection' style={{color:"white",display:"flex",justifyContent:"center",marginTop:"180px",marginBottom:"20px"}}>My Education</h1>
        <div style={{display:"flex",justifyContent:"center"}}>
        <VerticalTimeline>
  <VerticalTimelineElement
    contentStyle={{ background: 'rgba(253,156,45,0.92)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgba(253,156,45,0.92)' }}
    date="2021 - 2024"
    iconStyle={{ background: 'black', color: '#fff' }}
  >
    <h3 className="vertical-timeline-element-title" style={{fontWeight:"100",fontSize:"40px"}}>Lovely Professional University</h3>
    <h4 className="vertical-timeline-element-subtitle" style={{fontWeight:"100",fontSize:"20px"}}>Jalandhar</h4>
    <p style={{fontWeight:"100",fontSize:"20px"}}>
       Bachelor's degree in computer application
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
      contentStyle={{ background: 'rgba(253,156,45,0.92)', color: '#fff' }}
      contentArrowStyle={{ borderRight: '7px solid  rgba(253,156,45,0.92)' }}
      date="2020 - 2021"
    iconStyle={{ background: 'black', color: '#fff' }}
  >
    <h3 className="vertical-timeline-element-title" style={{fontWeight:"100",fontSize:"40px"}}>Army Public School</h3>
    <h4 className="vertical-timeline-element-subtitle" style={{fontWeight:"100",fontSize:"20px"}}>Sukna</h4>
    <p style={{fontWeight:"100",fontSize:"20px"}}>
        Senior Secondary
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
      contentStyle={{ background: 'rgba(253,156,45,0.92)', color: '#fff' }}
      contentArrowStyle={{ borderRight: '7px solid  rgba(253,156,45,0.92)' }}
      date="2018 - 2019"
    iconStyle={{ background: 'black', color: '#fff' }}
  >
    <h3 className="vertical-timeline-element-title" style={{fontWeight:"100",fontSize:"40px"}}>Army Public School</h3>
    <h4 className="vertical-timeline-element-subtitle" style={{fontWeight:"100",fontSize:"20px"}}>Sukna</h4>
    <p style={{fontWeight:"100",fontSize:"20px"}}>
        High School
    </p>
  </VerticalTimelineElement>
  </VerticalTimeline>
  
        </div>
    </div>
}